import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock, Loader2, Check } from "lucide-react";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [form, setForm] = useState({ password: "", confirm: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) { toast.error("Password must be at least 8 characters"); return; }
    if (form.password !== form.confirm) { toast.error("Passwords don't match"); return; }
    if (!token) { toast.error("Missing reset token"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: form.password });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) {
      toast.error("Reset failed", { description: e?.response?.data?.detail || "Link may be expired." });
    } finally { setLoading(false); }
  };

  return (
    <div className="container-x py-20 md:py-28 min-h-[70vh] flex items-center" data-testid="reset-password-page">
      <form onSubmit={submit} className="card-luxe p-8 md:p-10 max-w-md w-full mx-auto" data-testid="reset-form">
        <div className="flex items-center gap-2 mb-6">
          <Lock className="w-5 h-5 text-[#D4AF37]" />
          <h2 className="font-serif text-2xl">Set new password</h2>
        </div>
        {done ? (
          <div className="text-center py-6" data-testid="reset-success">
            <div className="w-14 h-14 rounded-full bg-[#0B5D3B]/10 flex items-center justify-center mx-auto mb-4">
              <Check className="w-7 h-7 text-[#0B5D3B]" />
            </div>
            <h3 className="font-serif text-xl mb-2">Password updated</h3>
            <p className="text-sm text-[#4A554E]">Redirecting you to sign in…</p>
          </div>
        ) : (
          <>
            <label className="overline">New password (min 8)</label>
            <input type="password" required minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full px-5 py-3.5 mt-2 mb-5 rounded-full border border-[#EAE3D2] focus:border-[#0B5D3B] focus:outline-none"
              data-testid="reset-new" />
            <label className="overline">Confirm</label>
            <input type="password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })}
              className="w-full px-5 py-3.5 mt-2 mb-7 rounded-full border border-[#EAE3D2] focus:border-[#0B5D3B] focus:outline-none"
              data-testid="reset-confirm" />
            <button disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="reset-submit">
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Saving…</> : "Update password"}
            </button>
            <Link to="/login" className="block text-center mt-5 text-sm text-[#7A8A81] hover:text-[#111]">Back to sign in</Link>
          </>
        )}
      </form>
    </div>
  );
}
